import { render, staticRenderFns } from "./ExportDaftarPajak.vue?vue&type=template&id=7b345b36&scoped=true"
import script from "./ExportDaftarPajak.vue?vue&type=script&lang=js"
export * from "./ExportDaftarPajak.vue?vue&type=script&lang=js"
import style0 from "./ExportDaftarPajak.vue?vue&type=style&index=0&id=7b345b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b345b36",
  null
  
)

export default component.exports